import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-webpack-spinner";
import { Link } from "react-router";

class ValidateRegistration extends React.Component {
  componentDidMount() {
    this.props.onValidate(this.props.hash);
  }

  render() {
    const { token } = this.props;
    const waiting = !token;

    return (
      <div className="column is-6 is-offset-1 content overflow-scroll">
        {waiting && (
          <div>
            <h1 className="title">Registrierung abschließen</h1>
            <Spinner width={32} height={32} color="#000" />
            Einen Augenblick...
          </div>
        )}
        {!waiting && (
          <div>
            <h1 className="title">Herzlich willkommen!</h1>
            <p>
              Ihre Registrierung ist abgeschlossen, und sie sind bereits
              eingeloggt.
            </p>
            <Link to="/" className="button is-primary">
              zur Karte
            </Link>
          </div>
        )}
      </div>
    );
  }
}

ValidateRegistration.propTypes = {
  token: PropTypes.string,
  onValidate: PropTypes.func
};

export default ValidateRegistration;



/** WEBPACK FOOTER **
 ** ./src/components/ValidateRegistration.jsx
 **/